var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Select',_vm._b({staticClass:"multiselect",attrs:{"model":_vm.localModel,"field":{
      ..._vm.$attrs,
      name: _vm.name,
      placeholder: _vm.placeholder,
      filterable: _vm.filterable,
      multiple: true,
      type: 'relate'
    },"size":_vm.$attrs.size,"options":_vm.newOptions,"arrow-multiselect-focus":true,"popper-class":_vm.$attrs['popper-class']},on:{"set-value":_vm.onChange,"filter-option":_vm.filterOption}},'Select',_vm.$attrs,false)),_c('div',{staticClass:"tag-frame"},_vm._l((_vm.value),function(tag){return _c('Tag',{key:`${tag}-tag`,staticClass:"tag-frame__item",attrs:{"id":tag,"size":"middle","closable":true,"name":_vm.formatHtml(_vm.options[tag])},on:{"close":_vm.removeValue}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }